import React, { ReactNode } from 'react'
import { useTranslation } from 'next-i18next'
import { twJoin } from 'tailwind-merge'
import { PrimaryButtonWithCustomTheme } from 'modules/course/components/primary-button-with-custom-theme'
import { useGetCoursePageUrl } from 'modules/course/hooks/use-course-path-url'
import useStepRouter from 'modules/course/hooks/use-step-router'
import { CourseLectureId } from 'modules/course/types/course-lecture-interface'
import { CourseStepEnum } from 'modules/course/types/course-step-type'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'
import { CourseInfoScreenLayout } from './course-info-screen-layout'

interface CourseNeedCompleteAssignmentScreenProps {
  blockingAssignmentId?: CourseLectureId
}

export const CourseNeedCompleteAssignmentScreen = ({
  blockingAssignmentId,
}: React.PropsWithChildren<CourseNeedCompleteAssignmentScreenProps>): ReactNode => {
  const { t } = useTranslation()

  const coursePath = useGetCoursePageUrl()
  const { findStepById, findStep } = useStepRouter()

  let step = findStepById(blockingAssignmentId)

  if (!step?.available) {
    step = findStep()
  }

  const href = step
    ? `/school/course/${coursePath}/${CourseStepEnum.assignment}/${step.id}`
    : `/school/course/${coursePath}`

  return (
    <CourseInfoScreenLayout
      className={addPublicCustomClassNamePrefix(`course__info-screen--need-to-complete-assignment`)}
      text={t('course.lecture.assignment.complete_previous_assignment')}
      buttons={
        <PrimaryButtonWithCustomTheme
          className={twJoin(
            `font-bold`,
            addPublicCustomClassNamePrefix('course__button--go-to-uncompleted-assignment'),
          )}
          href={href}
        >
          {t('course.lecture.assignment.go_to_assignment_button')}
        </PrimaryButtonWithCustomTheme>
      }
    />
  )
}
